import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs } from "firebase/firestore";
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
import PatientProfileModal from "../../components/ui/PatientProfileModal/PatientProfileModal";
import moment from "moment";

const { Search } = Input;

const rows: any = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    render: (text: any, record: any, index: number) => index + 1,
  },
  {
    title: "Patient Name",
    dataIndex: "username",
    key: "username",
    sorter: (a: any, b: any) => a.username.localeCompare(b.username),
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
    render: (phone: any) => (phone ? phone : '--'),
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    sorter: (a: any, b: any) => a.category.localeCompare(b.category),
    render: (category: any) => (category ? category : '--'),
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
    render: (createdAt: any) => (createdAt ? moment(new Date(createdAt.seconds * 1000)).format('MMMM D, YYYY') : '--'),
  },
];

const override = {
  marginTop: "20px",
};


function Index() {
  const [allScreeningData, setAllScreeningData] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allScreeningData);

  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const toggleAddModal = async () => {
    // fetchUsers().then(doc => console.log(doc.data()))
    setShowCreateModal(!showCreateModal);
  };

  const handleContentAdded = () => {
    toggleAddModal();
    //FETCH DATA
    fetchData();
  };

  
  

  const fetchData = async () => {
    setLoading(true);


    const querySnapshot = await getDocs(collection(db, "Screening"));

    const screeningData: any = [];

    querySnapshot.forEach((doc) => {
      screeningData.push({
        ...doc.data()
      })
      console.log(doc.id, " => ", doc.data());
    });

    setAllScreeningData(screeningData)

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  allScreeningData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  const sortByDate = (a: any, b: any) => {
    const dateA: any = new Date(a.createdAt.seconds * 1000 + a.createdAt.nanoseconds / 1000000);
    const dateB: any = new Date(b.createdAt.seconds * 1000 + b.createdAt.nanoseconds / 1000000);
    return dateB - dateA;
  };

  useEffect(() => {
    const sortedData = allScreeningData.sort(sortByDate);

      //  console.log('PATIENT DATA: ', allScreeningData);
    setFilteredData(filterData(sortedData, searchText));
  }, [allScreeningData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };


  return (
    <>
    <Layout title="Screen Request" pageTitle="screening">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>All Screening Request</h3>
              </div>

              {/* <button 
               onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Patient
              </button> */}
            </div>
            <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                <Table

                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}

                  columns={rows}
                  onChange={handleChange}
                  rowKey="num"
                  showSorterTooltip={false}

                  pagination={{ pageSize: 10 }}
                />

              </div>
  
          </div>
        </div>
      </div>
    </Layout>
    </>
  );
}

export default Index;
